/** Marks the redirect iframe wrapper — parent must not capture/prevent clicks here. */
export const REDIRECT_EMBED_ROOT_SEL = '[data-hcva-redirect-embed="root"]';

/** Single-segment paths used for rotating “shortlink” URLs (not real shop routes). */
export const REDIRECT_SLUG_LEN = 10;

const SLUG_CHARS = 'abcdefghijklmnopqrstuvwxyz0123456789';

export function generateRedirectSlug() {
  let s = '';
  for (let i = 0; i < REDIRECT_SLUG_LEN; i += 1) {
    s += SLUG_CHARS[Math.floor(Math.random() * SLUG_CHARS.length)];
  }
  return s;
}

/** True if pathname is our embed shortlink, e.g. /x7k2m9a1b4 */
export function isRedirectShortlinkPath(pathname) {
  const p = (pathname || '').replace(/\/$/, '') || '/';
  const m = p.match(/^\/([a-z0-9]+)$/i);
  if (!m) return false;
  return m[1].length === REDIRECT_SLUG_LEN;
}

export function isValidRedirectEmbedSlug(slug) {
  if (!slug || typeof slug !== 'string') return false;
  if (slug.length !== REDIRECT_SLUG_LEN) return false;
  return /^[a-z0-9]+$/i.test(slug);
}

/** Ensures CB5 landings see hcva_embed=1 (with iframe self!==top, CB5 still picks embed Esc-hold path). */
export function withHcvaEmbedParam(href) {
  if (!href || typeof href !== 'string') return href;
  try {
    const u = new URL(href, typeof window !== 'undefined' ? window.location.href : undefined);
    u.searchParams.set('hcva_embed', '1');
    return u.toString();
  } catch (_) {
    return href;
  }
}

/** @deprecated Use withHcvaEmbedParam */
export function withEmbedParam(href) {
  return withHcvaEmbedParam(href);
}
